// The Flappy Trump storyline — a satirical fly-through of actual events.
// Events fire when the player passes the given number of pipes (the score = "Day").
//
// Chapter 1: Liberation Day        — the tariffs go UP
// Chapter 2: The Art of the Deal   — the tariffs come DOWN
// Chapter 3: The 12-Day War        — Iran
// Chapter 4: Big Beautiful Debt    — the US debt spiral
// Chapter 5: Rise of the Robots    — AI everything
// Chapter 6: The Fallout           — protests, feuds and polls

export const CHAPTERS = [
  { from: 0, short: "Liberation Day", title: "📖 Chapter 1: Liberation Day", theme: "tariffs" },
  { from: 18, short: "The Art of the Deal", title: "📖 Chapter 2: The Art of the Deal", theme: "deals" },
  { from: 28, short: "The 12-Day War", title: "📖 Chapter 3: The 12-Day War", theme: "war" },
  { from: 36, short: "Big Beautiful Debt", title: "📖 Chapter 4: Big Beautiful Debt", theme: "debt" },
  { from: 45, short: "Rise of the Robots", title: "📖 Chapter 5: Rise of the Robots", theme: "ai" },
  { from: 54, short: "The Fallout", title: "📖 Chapter 6: The Fallout", theme: "fallout" },
];

export const getChapterIndex = (score) => {
  let index = 0;
  CHAPTERS.forEach((chapter, i) => {
    if (score >= chapter.from) index = i;
  });
  return index;
};

// Visual identity per event type (used by FloatingElement + Gallery)
export const TYPE_META = {
  tariff: { kicker: "⚡ TARIFF SLAPPED", className: "tariff" },
  deal: { kicker: "🤝 ART OF THE DEAL", className: "deal" },
  war: { kicker: "🚨 BREAKING NEWS", className: "war" },
  debt: { kicker: "💵 DEBT WATCH", className: "debt" },
  ai: { kicker: "🤖 ROBOT REPORT", className: "ai" },
  fallout: { kicker: "📉 THE FALLOUT", className: "fallout" },
};

export const storyline = {
  /* ---------- Chapter 1: Liberation Day — tariffs go UP ---------- */
  2: {
    type: "tariff",
    emoji: "📜",
    action: "Liberation Day! 10% baseline tariff on EVERY country",
    toast: "Liberation Day! Tariff is the most beautiful word in the dictionary.",
  },
  4: {
    type: "tariff",
    img: require("../../assets/tariffs/canada_mexico_tariff_200x300.png"),
    action: "25% tariff on Canada and Mexico",
    toast: "They're eating the dogs!",
  },
  6: {
    type: "tariff",
    img: require("../../assets/tariffs/eu_tariff_200x300.png"),
    action: "20% tariff on EU wine",
    toast: "OHH, the DEBT is getting paid",
  },
  8: {
    type: "tariff",
    img: require("../../assets/tariffs/japan_tariff_200x300.png"),
    action: "24% tariff on JDM cars",
    toast: "They'll pay. They always pay. Beautiful cars though.",
  },
  10: {
    type: "tariff",
    img: require("../../assets/tariffs/india_tariff_200x300.png"),
    action: "26% tariff on Curry",
    toast: "THAT CURRY SMELLS BAD MAN",
  },
  12: {
    type: "tariff",
    img: require("../../assets/tariffs/vietnam_tariff_200x300.png"),
    action: "46% tariff on Vietnam",
    toast: "Are the Nikes made in Vietnam?",
  },
  14: {
    type: "tariff",
    img: require("../../assets/tariffs/cambodia_tariff_200x300.png"),
    action: "49% tariff on Cambodia",
    toast: "Where is the money going?",
  },
  16: {
    type: "tariff",
    img: require("../../assets/tariffs/china_tariff_200x300.png"),
    action: "145% tariff on CHINA",
    toast: "CHINA CHINA CHINA",
  },

  /* ---------- Chapter 2: The Art of the Deal — tariffs come DOWN ---------- */
  18: {
    type: "deal",
    emoji: "📉",
    action: "90-day tariff pause announced",
    toast: "The markets were getting YIPPY. A little yippy!",
  },
  20: {
    type: "deal",
    emoji: "🤝",
    action: "China truce: tariffs cut from 145% to 30%",
    toast: "Very good call with Xi. He said beautiful things about me.",
  },
  22: {
    type: "deal",
    emoji: "🇬🇧",
    action: "UK trade deal signed",
    toast: "The special relationship. Very special. The King loves me.",
  },
  24: {
    type: "deal",
    emoji: "🇪🇺",
    action: "EU deal: 15% tariff and $750B of energy",
    toast: "They bought our beautiful energy. $750 billion worth!",
  },
  26: {
    type: "deal",
    emoji: "🇯🇵",
    action: "Japan deal: 15% tariff and $550B investment",
    toast: "They invest, we win. Everybody wins!",
  },

  /* ---------- Chapter 3: The 12-Day War — Iran ---------- */
  28: {
    type: "war",
    emoji: "🚀",
    action: "Israel strikes Iran's nuclear program",
    toast: "I gave them 60 days to make a deal. They should have taken it!",
  },
  30: {
    type: "war",
    emoji: "💥",
    action: "Operation Midnight Hammer: B-2s hit Fordow",
    toast: "Completely and totally OBLITERATED. Nobody has bombs like ours.",
  },
  32: {
    type: "war",
    emoji: "🎯",
    action: "Iran retaliates at US base in Qatar",
    toast: "They gave us a heads up. Very respectful. 14 missiles, 13 down, 1 was friendly.",
  },
  34: {
    type: "war",
    emoji: "🕊️",
    action: "CEASEFIRE — the 12-Day War is over",
    toast: "THE 12 DAY WAR IS OVER! Somebody get me the Nobel Prize!",
  },

  /* ---------- Chapter 4: Big Beautiful Debt ---------- */
  36: {
    type: "debt",
    emoji: "🖊️",
    action: "One Big Beautiful Bill signed into law",
    toast: "The biggest, most beautiful bill ever signed. Everybody's talking about it.",
  },
  38: {
    type: "debt",
    emoji: "🏛️",
    action: "Debt ceiling raised by $5 TRILLION",
    toast: "We raised it. Nobody raises a ceiling like me. Beautiful ceiling.",
  },
  40: {
    type: "debt",
    emoji: "💵",
    action: "National debt hits $37 TRILLION",
    toast: "37 trillion! So many zeros. The best zeros.",
  },
  42: {
    type: "debt",
    emoji: "🖨️",
    action: "Interest payments pass $1 TRILLION a year",
    toast: "We'll grow out of it. Or print more. Whatever works.",
  },
  44: {
    type: "debt",
    emoji: "📊",
    action: "Moody's downgrades the US credit rating",
    toast: "Moody's? Never heard of her. Probably a Democrat.",
  },

  /* ---------- Chapter 5: Rise of the Robots ---------- */
  45: {
    type: "ai",
    emoji: "🛰️",
    action: "Stargate: $500B AI megaproject announced",
    toast: "The biggest AI project in the history of the world. Maybe the universe.",
  },
  47: {
    type: "ai",
    emoji: "🤖",
    action: "AI Action Plan signed",
    toast: "America will WIN the AI race. No woke AI. Very awake AI.",
  },
  49: {
    type: "ai",
    emoji: "🚕",
    action: "Robotaxis flood the streets",
    toast: "The cars drive themselves! I still don't drive. I have people for that.",
  },
  51: {
    type: "ai",
    emoji: "🦾",
    action: "Optimus robots join the workforce",
    toast: "The robots brought me a Diet Coke. Tremendous service. No tips!",
  },
  53: {
    type: "ai",
    emoji: "⚡",
    action: "AI data centers drain the power grid",
    toast: "We'll power them with beautiful clean coal. The robots love coal.",
  },

  /* ---------- Chapter 6: The Fallout ---------- */
  54: {
    type: "fallout",
    emoji: "👑",
    action: "NO KINGS: millions march nationwide",
    toast: "Paid protesters! SAD! I am NOT a king. Although I'd be a great king.",
  },
  56: {
    type: "fallout",
    emoji: "📱",
    action: "Elon feud explodes online",
    toast: "Elon went CRAZY! I took away his EV mandate. He knew I would!",
  },
  58: {
    type: "fallout",
    emoji: "🗂️",
    action: "Epstein files backlash",
    toast: "It's a hoax! A beautiful hoax! Why is everyone still talking about it?!",
  },
  60: {
    type: "fallout",
    emoji: "📉",
    action: "Approval rating drops to 37%",
    toast: "Fake polls! The fakest polls in history. Everybody loves me.",
  },
  62: {
    type: "fallout",
    emoji: "🗳️",
    action: "Midterms looming...",
    toast: "We'll win in a landslide. And if we don't — rigged!",
  },
};

// Events unlocked for the gallery, sorted by day
export const getUnlockedEvents = (highScore) =>
  Object.entries(storyline)
    .map(([score, event]) => ({ ...event, score: parseInt(score, 10) }))
    .filter((event) => event.score <= highScore)
    .sort((a, b) => a.score - b.score);
